// extracted by mini-css-extract-plugin
module.exports = {"buttonIcon":"styles_buttonIcon__1-fiN","errorColor":"styles_errorColor__-5P5o","moreButton":"styles_moreButton__2DIkN"};